import { ReactNode } from 'react';
import ProductAnalysisModal from '@/components/ProductAnalysisModal';
import {
    GroupEditorModalWrapper,
    type GroupEditorModalWrapperProps,
} from '@/components/group-editor/GroupEditorModalWrapper';
import { ProductAnalysisEntity } from '@/entities/product-analysis.entity';

type AnalysisTargetBase = {
    name: string;
};

export type GroupTableModalsCoreProps<
    TAnalysisTarget extends AnalysisTargetBase,
    TGroupEditorItem,
    TGroupEditorTarget extends AnalysisTargetBase,
> = {
    openedAnalysisTarget: TAnalysisTarget | null;
    analysisData: ProductAnalysisEntity | null;
    isAnalysisLoading: boolean;
    analysisError: string | null;
    onAnalysisClose: () => void;
    groupEditorProps: Omit<
        GroupEditorModalWrapperProps<TGroupEditorItem, TGroupEditorTarget>,
        'totalLabel' | 'emptyStateLabel'
    >;
    groupEditorTotalLabel: string;
    groupEditorEmptyStateLabel: string;
    extraModals?: ReactNode;
};

export const GroupTableModalsCore = <
    TAnalysisTarget extends AnalysisTargetBase,
    TGroupEditorItem,
    TGroupEditorTarget extends AnalysisTargetBase,
>({
    openedAnalysisTarget,
    analysisData,
    isAnalysisLoading,
    analysisError,
    onAnalysisClose,
    groupEditorProps,
    groupEditorTotalLabel,
    groupEditorEmptyStateLabel,
    extraModals,
}: GroupTableModalsCoreProps<TAnalysisTarget, TGroupEditorItem, TGroupEditorTarget>) => (
    <>
        {openedAnalysisTarget && (
            <ProductAnalysisModal
                isShown={true}
                setIsShown={onAnalysisClose}
                data={analysisData}
                loading={isAnalysisLoading}
                error={analysisError}
                productName={openedAnalysisTarget.name}
            />
        )}
        {extraModals}
        <GroupEditorModalWrapper
            {...groupEditorProps}
            totalLabel={groupEditorTotalLabel}
            emptyStateLabel={groupEditorEmptyStateLabel}
        />
    </>
);
